import { Card, FormField, FormFieldRow, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { AquiferTestObservationWellFieldsView } from '../../../../types/form-types'
import { TestFieldsView } from './test-view'

export interface AquiferTestObservationWellsViewFormInterface {
  fields: Partial<AquiferTestObservationWellFieldsView>
  isLoading: boolean
  index: number
}

export default function AquiferTestObservationWellsViewForm({
  fields,
  isLoading,
  index,
}: AquiferTestObservationWellsViewFormInterface) {
  return (
    <Card>
      <Heading isSkeleton={isLoading} level={4}>
        {`Observation well ${index + 1}`}
      </Heading>
      <FormField isSkeleton={isLoading} label='Observation well' labelId={`observationWellLabel${index}`}>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy={`observationWellLabel${index}`}
          value={`${fields.observationWell ?? ''}`}
        />
      </FormField>

      <FormFieldRow>
        <FormField
          isSkeleton={isLoading}
          label='Distance to pumped well (m)'
          labelId={`distanceToPumpedWellLabel${index}`}
        >
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy={`distanceToPumpedWellLabel${index}`}
            value={`${fields.distanceToPumpedWell ?? ''}`}
          />
        </FormField>

        <FormField
          toolTipMessage={TOOLTIP.maxDrawdown}
          isSkeleton={isLoading}
          label='Max drawdown (m)'
          labelId={`maxDrawdownLabel${index}`}
        >
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy={`maxDrawdownLabel${index}`}
            value={`${fields.maxDrawdown ?? ''}`}
          />
        </FormField>
      </FormFieldRow>

      <TestFieldsView fields={fields} isLoading={isLoading} index={index} />

      <FormField isSkeleton={isLoading} label='Comment' labelId={`commentLabel${index}`}>
        <ReadOnlyField isSkeleton={isLoading} labelledBy={`commentLabel${index}`} value={`${fields.comment ?? ''}`} />
      </FormField>
    </Card>
  )
}
